import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes,  Route } from 'react-router-dom';

import reportWebVitals from './reportWebVitals';
import HomePage from './pages/HomePage';
import SevenYearModelPage from './pages/SevenYearModelPage';
// import Carousel from './pages/Carousel';
import CallForAgricOffice from './pages/CallForAgricOffice';
import GrassrootForAfricaForm from './pages/GrassrootForAfricaForm';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <React.StrictMode>
      <Routes>       
            <Route path='/' element={<HomePage />} />
            <Route path='/seven-year-model' element={<SevenYearModelPage />} /> 
            {/* <Route path='/carousel' element={<Carousel />} />  */}
            <Route path='/call-for-agric-office' element={<CallForAgricOffice />} /> 
            <Route path='/grassroot-for-africa-form' element={<GrassrootForAfricaForm />} /> 
            {/* <Route path='/donate' element={<Donate />} />   
            <Route path='/apply-service/:service-title' element={<ApplyService />} />  
            <Route path = '/call-for-experts' element={<CallForExpertsPage />} /> */}
          </Routes> 
    </React.StrictMode>
  </Router>
);

reportWebVitals();
